import { ImageProps } from './component';
import { ImageRendererExtraProps } from './renderer';

export type ImageControlsProps = ImageProps & ImageRendererExtraProps;
